import React, { useEffect } from 'react'
import img from '../../Image/about_img2.png'
import people from '../../Image/people.svg'
import integrity from '../../Image/integrity.svg'
import success from '../../Image/success.svg'
import Aos from 'aos'

const AboutSection2 = () => {

   useEffect(() => {
      Aos.init({
        duration: 1000,   // optional: animation duration in ms
        once: true,       // optional: whether animation should happen only once
      });
    }, []);

  return (
    <div className='sm:mt-10  sm:pb-11 pb-5'>
        <div className='container'>
          <div className='flex  justify-center pb-10'>
             <div className='3xl:w-5/6 w-full'>
                <div className='bg-theme_light py-11 sm:px-11 px-8 rounded-[30px]'>
                    <div className='flex lg:flex-row flex-col-reverse flex-wrap  items-center'>
                        <div className='lg:w-1/3 w-full  lg:pe-10 lg:mt-0 mt-10 flex lg:justify-start justify-center' >
                          <img data-aos="zoom-in-down" data-aos-duration="1000" src={img} alt=""  className='w-[370px]'/>
                        </div>
                        <div className='lg:w-2/3 w-full '>
                           <div className='flex sm:flex-nowrap flex-wrap sm:justify-start justify-center items-center'>
                               <div>
                                  <div  className='md:w-[130px] md:h-[130px] w-[100px] h-[100px] bg-white shadow-[0px_0px_4px_0px_#00000040] rounded-[50%] flex justify-center items-center'>
                                     <img data-aos="flip-left" src={people} alt="" />
                                  </div>
                               </div>
                               <div className='sm:ms-10 sm:mt-0 mt-5'>
                                  <h4 className='text-txt_color sm:text-[24px] text-[18px] font-[700] sm:text-start text-center'>PEOPLE</h4>
                                  <p className='text-[#555555] sm:text-[16px] text-[14px] sm:text-start text-center'>We perpetuate a positive sparkling surrounding, that can encourage growth and strenghtens working bond and growth.</p>
                               </div>
                           </div>
                           <div className='flex sm:flex-nowrap flex-wrap sm:justify-start justify-center items-center mt-7'>
                               <div>
                                  <div className='md:w-[130px] md:h-[130px] w-[100px] h-[100px] bg-white shadow-[0px_0px_4px_0px_#00000040] rounded-[50%] flex justify-center items-center'>
                                     <img data-aos="flip-left" src={integrity} alt="" />
                                  </div>
                               </div>
                               <div className='sm:ms-10 sm:mt-0 mt-5'>
                                  <h4 className='text-txt_color sm:text-[24px] text-[18px] font-[700] sm:text-start text-center'>INTEGRITY</h4>
                                  <p className='text-[#555555] sm:text-[16px] text-[14px] sm:text-start text-center'>We hold ourselves to the highest ethical standards, consistently demonstrating honesty, transparency, and accountability in all that we do.</p>
                               </div>
                           </div>
                           <div className='flex sm:flex-nowrap flex-wrap sm:justify-start justify-center items-center mt-7'>
                               <div>
                                  <div className='md:w-[130px] md:h-[130px] w-[100px] h-[100px] bg-white shadow-[0px_0px_4px_0px_#00000040] rounded-[50%] flex justify-center items-center'>
                                     <img data-aos="flip-left" src={success} alt="" />
                                  </div>
                               </div>
                               <div className='sm:ms-10 sm:mt-0 mt-5'>
                                  <h4 className='text-txt_color sm:text-[24px] text-[18px] font-[700] sm:text-start text-center'>SUCCESS</h4>
                                  <p className='text-[#555555] sm:text-[16px] text-[14px] sm:text-start text-center'>Success is not just measured by financial achievements, but by the positive impact we make on our clients, employees, and communities.</p>
                               </div>
                           </div>
                        </div>
                    </div> 
                </div>
             </div>
          </div>
        </div>
    </div>
  )
}

export default AboutSection2
